import CandidateProject, { CandidateProjectType } from '../CandidateProject';

export default function CandidateProjects(props: CandidateProjectType): JSX.Element {
  return <CandidateProject {...props} />;
}
